import type {Visibility} from "./VisibilityModel.ts";
import type {FogFrame} from "./useSoftFogWorker.ts";

export function presentedFog(visibility: Visibility, frame: FogFrame | undefined, unavailable: boolean) {
    const displayedFrame = visibility.enabled && !unavailable && frame
        && frame.scene.levelId === visibility.levelId
        && frame.scene.radiusMeters === visibility.radiusMeters ? frame : undefined;
    if (!visibility.enabled) return {visibility, frame: undefined};
    if (unavailable) return {
        visibility: {...visibility, areas: [], lights: [], polygons: []},
        frame: undefined,
    };
    const areas = displayedFrame?.scene.areas ?? [];
    const staleGeometry = displayedFrame !== undefined
        && displayedFrame.scene.blockerKey !== visibility.blockerKey;
    return {
        visibility: {...visibility, areas,
            // Keep recognition in step with the published light frame. A door change
            // must still use current blockers/illumination immediately, without flashing black.
            lights: staleGeometry ? visibility.lights : displayedFrame?.scene.lights ?? [],
            lighting: staleGeometry ? visibility.lighting : displayedFrame?.scene.lighting,
            // Closing a door clips the old image immediately; opening one remains dark
            // in the old image until the new mask arrives.
            polygons: staleGeometry ? visibility.polygons : areas.map(area => area.polygon),
            staleGeometry,
        },
        frame: displayedFrame,
    };
}
